import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Descriptions,
  Row,
  Space,
  Tag,
  Tooltip,
} from "antd";
import { ReactComponent as UserSvg } from "../../../assets/images/description/User.svg";
import { ReactComponent as EmailSvg } from "../../../assets/images/description/Message.svg";
import { ReactComponent as CalenderSvg } from "../../../assets/images/description/calendar.svg";
import { Link, useNavigate, useParams } from "react-router";
import { ReactComponent as DeactivateSvg } from "../../../assets/images/action/deactivate.svg";
import { ReactComponent as MicSvg } from "../../../assets/images/description/Mic.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/deleteWhite.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import BackArrowImg from "../../../assets/images/arrowLeft.png";
import { ReactComponent as EnableSvg } from "../../../assets/images/action/Shield Check.svg";
import ReusableTable from "../../../components/common/table";
import ConfirmModal from "../../../components/common/alert-popup";
import {
  deleteUser,
  getTenantUserActivity,
  getUserData,
  getUserDetailsData,
  updateStatus,
} from "../../../redux/action/user-management/userManagementAction";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";

// Breakpoints
const descriptions_breakpoint = {
  xxl: 4,
  xl: 4,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1,
};

const ViewUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };
  const [tableParams, setTableParams] = useState({
    page: 1,
    size: 10,
    search_value: "",
    search_key: "",
    status: undefined,
    position: undefined,
  });
  const columns = [
    {
      title: "SR. NO.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
    },
    {
      title: "Podcast Title",
      dataIndex: "title_en",
      key: "title_en",
      render: (text) => (
        <Tooltip title={text}>
          {text?.length > 15 ? text.substring(0, 15) + "..." : text}
        </Tooltip>
      ),
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      render: (text) => text ?? "N/A",
    },
    {
      title: "Last Played Date",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (updated_at) =>
        updated_at ? dayjs(updated_at).format("MM-DD-YYYY") : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      render: (status) => {
        const isActive = status === 1;
        return (
          <Tag
            color={isActive ? "#E6F4EA" : "#FCE8E8"}
            style={{
              color: isActive ? "#22AD5C" : "#FF5D5D",
            }}
            className="custom-tag"
          >
            {isActive ? "Completed" : "In progress"}
          </Tag>
        );
      },
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
      ],
    },
  ];

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  const data = useSelector((store) => store.getUserDetails?.dataDetails);
  const { isLoading } = useSelector((store) => store.getUserDetails);

  useEffect(() => {
    if (params?.id) {
      dispatch(getUserDetailsData(params.id, { page: tableParams.page, size: tableParams.size }));
    }
  }, [params?.id, dispatch]);

  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <UserSvg /> User’s Name
        </>
      ),
      children: data?.name_en ?? "Mark Lewis",
    },
    {
      key: "2",
      label: (
        <>
          <EmailSvg /> Email
        </>
      ),
      children: data?.email ?? "marklewis@gmail.com",
    },
    {
      key: "3",
      label: (
        <>
          <UserSvg /> Account Status
        </>
      ),
      children: data?.status == 1 ? "Active" : "Inactive",
    },
    {
      key: "4",
      label: (
        <>
          <CalenderSvg /> Date Added
        </>
      ),
      children: dayjs(data?.created_at).format("MM-DD-YYYY") ?? "-",
    },
    {
      key: "5",
      label: (
        <>
          <MicSvg /> Podcast Completed
        </>
      ),
      children: data?.complete_listened_count ?? "0",
    },
  ];

  const handleDelete = () => {
    if (params?.id) {
      dispatch(
        deleteUser(
          {
            url: ApiUrl.CLIENT_USER_DATA_GET,
            id: `user_id=${params?.id}`,
          },
          (res) => {
            dispatch(getUserData());
            closeModal();
            navigate(-1);
          }
        )
      );
    }
  };
  const handleUpdateStatus = () => {
    const newStatus = data?.status === 0 ? 1 : 0;
    if (params?.id) {
      dispatch(
        updateStatus(
          {
            url: ApiUrl.CLIENT_USER_DATA_GET,
            id: `user_id=${params?.id}`,
            status: `status=${newStatus}`,
          },
          (res) => {
            dispatch(getUserData());
            closeModal();
            navigate(-1);
          }
        )
      );
    }
  };

  useEffect(() => {
    if (params?.id) {
      dispatch(getTenantUserActivity({id: params.id, ...tableParams}));
    }
  }, [params?.id, tableParams, dispatch]);

  const activityData = useSelector((store) => store.getUserActivity?.data);
  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: activityData?.count ?? 0,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      // setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };
  return (
    <>
      <div className="viewTenant">
        <div
          className="backToLogin mt-3"
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer" }}
        >
          <img src={BackArrowImg} alt="BackArrowImg" />
          <div className="tableHeading">View User Details</div>
        </div>

        <Space>
          <Button
            type="text"
            onClick={() => navigate(`/user-management/edit-user/${params?.id}`)}
            icon={<EditSvg />}
            className="editTextBtn"
          >
            Edit Details
          </Button>{" "}
          <Button
            // type="link"
            onClick={
              data?.status == 1
                ? () => showModal("deactivate")
                : () => showModal("activate")
            }
            icon={data?.status == 1 ? <DeactivateSvg /> : <EnableSvg />}
            className={data?.status == 1 ? "deactivate" : "activate"}
          >
            {data?.status == 1 ? "Deactivate" : "Activate"}
          </Button>
          <Button
            type="danger"
            onClick={() => showModal("delete")}
            icon={<DeleteSvg />}
            className="delete"
          >
            Delete
          </Button>
        </Space>
      </div>
      <Card loading={isLoading}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24}>
            <div className="customDescription">
              <Descriptions
                className="custom_descriptions"
                layout="vertical"
                items={basicInfo_details}
                size="small"
                column={{ xs: 1, sm: 2, md: 3 }}
              />
            </div>
          </Col>
        </Row>
      </Card>
      <div className="tableHeading mt-2">User’s Activity </div>
      <ReusableTable
        columns={columns}
        data={activityData?.rows ?? []}
        loading={false}
        paginationConfig={{
          ...paginationConfig,
          ...tableParams.pagination,
        }}
        actionItems={[]}
      />
      <ConfirmModal
        open={modalConfig.open}
        titlePrefix="User"
        messagePrefix="User"
        onClose={closeModal}
        onConfirm={
          modalConfig.actionType === "delete"
            ? handleDelete
            : () => handleUpdateStatus()
        }
        actionType={modalConfig.actionType}
      />
    </>
  );
};

export default ViewUser;
